// source: legebill/type/narrative_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.legebill.type.NarrativeType', null, global);
/**
 * @enum {number}
 */
proto.legebill.type.NarrativeType = {
  NARRATIVE_TYPE_UNSPECIFIED: 0,
  NARRATIVE_ONLY: 1,
  NARRATIVE_AND_TIME_ROW_DESCRIPTIONS: 2
};

goog.object.extend(exports, proto.legebill.type);
